import React, { ComponentType } from 'react';
import { CellProps } from 'react-table';
import { usePaymentProviderContext } from '../../Session/PaymentProviderContext';
import { AmountCell } from '../common/table/TableComponents';
import { CreditMemoCell } from './CreditMemoCell';
import { ApplicationPartType, BillingItemType, BillingTableItem } from './types';
import { useApplicationParts } from './useApplicationParts';

const applicationPartType: Record<BillingItemType, ApplicationPartType> = {
  debitMemo: 'debitmemos',
  invoice: 'invoices',
};

export const InvoiceAmountCell: ComponentType<CellProps<BillingTableItem, number>> = ({
  value,
  row,
}) => {
  const { currencyOptions } = usePaymentProviderContext();
  const applicationParts = useApplicationParts(
    applicationPartType[row.original.itemType],
    row.original.Id,
  );
  const sumOfAppliedCreditMemos = applicationParts.reduce(
    (acc, applicationPart) =>
      acc + (applicationPart.creditMemoId ? applicationPart.appliedAmount : 0),
    0,
  );
  const displayCreditMemoAmount = sumOfAppliedCreditMemos > 0;
  return displayCreditMemoAmount ? (
    <CreditMemoCell
      value={value}
      creditMemoAmount={sumOfAppliedCreditMemos}
      options={currencyOptions}
    />
  ) : (
    <AmountCell value={value} options={currencyOptions} />
  );
};
